// API configuration
const config = {
  API_URL: process.env.REACT_APP_API_URL || 'https://hqln2txwrk.execute-api.us-east-1.amazonaws.com/dev',
  USERNAME: 'ravsau', // Fixed username for MVP
};

export default config;
